import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { canUseDOM } from 'exenv';
import get from 'lodash/get';
import chunk from 'lodash/chunk';
import extend from 'lodash/extend';
import { withRouter } from 'react-router';
import Slider from 'react-slick';
import Ad from '../../../components/ad/ad';
import NotFound from '../../../components/not_found_component/not_found_component';
import FranchiseIntro from '../../../components/franchise_intro/franchise_intro';
import Slug from '../../../components/slug/slug';
import FCLink from '../../../components/fc_link/fc_link';
import legacyImageAssetUtil from '../../../../utils/legacy_image_asset_util';

function Company(company, sector = false) {
  return (
    <div
      className={`mic-year-page__slide-company${sector
        ? ' mic-year-page__slide-company--sector'
        : ''}`}
      key={`company-${company.name}`}
    >
      <FCLink to={`/company/${company.url}`}>
        <div className="mic-year-page__slide-company-content">
          <h2>
            <span className="mic-year-page__slide-company-rank">
              {Number(company.ranking) < 10 ? '0' : ''}{company.ranking}
            </span>
            <span className="mic-year-page__slide-company-name">
              {company.name}
            </span>
          </h2>
          {company.why || company.for
            ? <h3 className="mic-year-page__slide-company-reason">
                {company.why || company.for}
              </h3>
            : null}
        </div>
      </FCLink>
    </div>
  );
}

function CompanySection(companies) {
  return (
    <section
      className="mic-year-page__slide"
      key={`mic-section-${get(companies, '[0].name')}`}
    >
      {companies.map(cpy => Company(cpy, false))}
    </section>
  );
}

function SectorSection(micYear, year, sectorName) {
  return function SectorSectionComponent(sector) {
    const sectorUrl = get(sector, 'url');
    return (
      <section
        className={`franchise-accordion-section franchise-accordion-section--mic-year franchise-accordion-section--${sectorUrl}`}
        key={`section-${get(sector, 'name')}`}
      >
        <Link
          className="franchise-accordion-section__title-row franchise-accordion-section--mic-year__title-row"
          to={
            sectorUrl === sectorName
              ? `/most-innovative-companies/${year}`
              : `/most-innovative-companies/${year}/sectors/${sectorUrl}`
          }
        >
          <h2 className="franchise-accordion-section__title franchise-accordion-section--mic-year__title">
            {sector.name}
          </h2>
          <img
            className={`franchise-accordion-section__title-icon franchise-accordion-section--mic-year__title-icon${sectorUrl ===
              sectorName
              ? ' franchise-accordion-section__title-icon--active'
              : ''}`}
            src="//assets.fastcompany.com/image/upload/q_auto,fl_lossy/v1495723987/arrow-list-down-fix.svg"
            alt="arrow icon"
            title="arrow icon"
          />
        </Link>
        <div
          className={`franchise-accordion-section__list franchise-accordion-section--mic-year__list${sectorUrl ===
            sectorName
            ? ' franchise-accordion-section--mic-year__list--active'
            : ''}`}
        >
          {sector.list.map(cpy => Company(cpy, true))}
        </div>
      </section>
    );
  };
}

// eslint-disable-next-line react/prefer-stateless-function
class MicYear extends PureComponent {
  constructor(props) {
    super(props);

    const prevArrow = (
      <button type="button">
        PREV
      </button>
    );

    const nextArrow = (
      <button type="button">
        NEXT
      </button>
    );

    this.state = {
      sector: get(this, 'props.match.params.sector'),
      settings: {
        prevArrow,
        nextArrow,
        className: 'mic-year-page__slider',
        infinite: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              slide: '.mic-section-slide'
            }
          },
          {
            breakpoint: 100000,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              slide: '.mic-section-slide'
            }
          }
        ]
      }
    };
  }

  componentDidMount() {
    this.updateDisplay(this.state.sector);
  }

  componentWillReceiveProps() {
    this.setState({ sector: get(this, 'props.match.params.sector') });
    this.updateDisplay(this.state.sector);
  }

  componentDidUpdate() {
    this.updateDisplay(this.state.sector);
  }

  animatedScroll(element, to, duration) {
    if (duration <= 0) return;
    const difference = to - element.scrollTop;
    const perTick = difference / duration * 10;

    setTimeout(() => {
      // eslint-disable-next-line no-param-reassign
      element.scrollTop += perTick;
      if (element.scrollTop === to) return;
      this.animatedScroll(element, to, duration - 10);
    }, 10);
  }

  updateDisplay(activeSection) {
    if (activeSection && canUseDOM) {
      this.screenLarge = window.innerWidth > 640;
      const el = document.querySelector(
        `.franchise-accordion-section--${activeSection}:not(.scrolled)`
      );
      if (el) {
        this.animatedScroll(document.body, el.offsetTop - 90, 100);
        el.classList.add('scrolled');
      }
    }
  }

  render() {
    if (this.props.micYearPage.error || this.props.status === 404) {
      return (
        <section className="tag-page">
          <article className="tag-page__main--error-pg">
            <NotFound />
          </article>
        </section>
      );
    }

    if (!this.props.micYearPage.isLoading) {
      const adData = get(this.props, 'micYearPage.ads');
      const combinedAdModel = extend(
        {},
        { baseConfig: get(adData, 'config.baseConfig') },
        { definitions: get(adData, 'config.definitions') },
        { model: get(adData, 'model') }
      );

      const year = this.props.year;
      const encodedText = encodeURIComponent(
        `@FastCompany's Most Innovative Companies ${year} #FCMostInnovative`
      );
      const uri = `https://www.fastcompany.com/most-innovative-companies/${year}`;

      const { settings } = this.state;

      return (
        <section className={`mic-year-page`}>
          <Ad {...combinedAdModel} name="oop" slug="false" oop="true" />

          <div className="ad-container ad-container--gray ad-container--hide-for-small">
            <Ad {...combinedAdModel} name="flexiblebillboard_1" />
          </div>

          <FranchiseIntro
            poster={legacyImageAssetUtil(
              get(this.props, 'micYearDescription.data.rows[0].logo_url')
            )}
            title={`Most Innovative Companies ${year}`}
            desc={get(this.props, 'micYearDescription.data.rows[0].intro')}
            social={{
              enableSticky: false,
              modifier: 'feature-feed',
              text: encodedText,
              uri
            }}
          />

          <Slug className="mic-year-page" slugName="Honorees by Rank" />

          <div className="mic-year-page__slider-row">
            <Slider {...settings}>
              {this.props.micYear.map(CompanySection)}
            </Slider>
          </div>

          <Slug className="mic-year-page" slugName={`Honorees by Sector`} />

          {this.props.micSector.map(
            SectorSection(
              this.props.micYear,
              this.props.year,
              this.state.sector
            )
          )}

          <div className="ad-container">
            <Ad {...combinedAdModel} name="flexiblebillboard_2" />
            <Ad {...combinedAdModel} name="mobilerectangle_1" />
          </div>
        </section>
      );
    }
    return null;
  }
}

/* eslint-disable */
function mapStateToProps(state = {}) {
  const micData = chunk(get(state, 'micYear.data.rows'), 10);
  return {
    config: state.config || {},
    status: state.status.code,
    micYearPage: get(state, 'micYearPage') || {error: true},
    micYear: micData || {error: true},
    year: get(state, 'micYear.year'),
    micSector: get(state, 'micSector.data.rows'),
    micYearDescription: get(state, 'micYearDescription'),
    micYearFeaturedFeed: get(state, 'micYearFeaturedFeed') || {error: true},
    micYearScrollingModule: get(state, 'micYearScrollingModule.data') || {error: true}
  };
}

MicYear.propTypes = {
  status: PropTypes.number,
  micYearPage: PropTypes.shape({
    ads: PropTypes.object,
    isLoading: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string
  }),
  year: PropTypes.string,
  micYear: PropTypes.arrayOf(
    PropTypes.arrayOf(
      PropTypes.shape({})
    )
  ),
  micYearDescription: PropTypes.shape({}),
  micSector: PropTypes.arrayOf(
      PropTypes.shape({})
  ),
  micYearFeaturedFeed: PropTypes.shape({}),
  micYearScrollingModule: PropTypes.shape({})
};

MicYear.defaultProps = {};
/* eslint-enable */

export default withRouter(connect(mapStateToProps)(MicYear));



// WEBPACK FOOTER //
// ./src/views/containers/pages/mic_year_page/mic_year_page.js